import { MutationTree } from 'vuex'
import { SubscriptionState } from './types'
export const mutations: MutationTree<SubscriptionState> = {
  addThingSubscription(state, payload) {
    state.subscriptions.things.updated.push(payload.subscription)
  },
  removeSubscriptionFromState(state, subscriptionId) {
    const idx = state.subscriptions.things.updated.findIndex(
      (el: any) => el.id === subscriptionId
    )
    if (idx !== -1) state.subscriptions.things.updated.splice(idx, 1)
  },
  cleanSubscriptionState(state) {
    state.subscriptions.things.updated = []
  }
}
